module.exports = __webpack_public_path__ + "static/img/picoNesalMask.c9d242c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/picoNesalMask.png
// module id = Fe19
// module chunks = 1